import { Box, Button, Flex, Image, useToast } from "@chakra-ui/react";
import { loginSuccess } from "actions/authentication";
import { useApi } from "hooks/useApi";
import { useAuthentication } from "hooks/useAuthentication";
import { useCallback, useContext, useMemo, useRef } from "react";
import { usePaystackPayment } from "react-paystack";
import { Store } from "store";
import { closeLoader, openLoader, showToast, toastTypes } from "utils";

export default function QRCodeSection(props:any) {
  const payment_reference = useMemo(() => new Date().getTime().toString(), []);
  const { verifyPayment, getUserProfile } = useApi();
  const loadingRef = useRef<any>(null);
  const {user} = useAuthentication()
  const { dispatch } = useContext(Store);
  const toast = useToast();
  const config: any = () => {
    return {
      currency: process.env.REACT_APP_PAYSTACK_CURRENCY as string,
      reference: payment_reference,
      email:  user?.user?.email,
      firstname:  user?.user?.name.split(" ")[1],
      lastname:  user?.user?.name.split(" ")[0],
      phone:  user?.user?.phone_number,
      amount: user?.user?.tax_amount_due * 100, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
      publicKey: user?.user?.payment_api_pk as string,
      metadata: {
        assessment_reference: user?.user?.assessment_reference,
      },
    };
  };
  const initializePayment: any = usePaystackPayment(config());
  const handlePayment = useCallback(
    async (response: any) => {
      openLoader(loadingRef);
      const { reference } = response;
      if (response.reference) {
        const verifyResponse = await verifyPayment({
          reference: reference,
          assessment_reference: user?.user?.assessment_reference,
        });
        if (verifyResponse.id) {
          response = await getUserProfile(user?.user?.id);
          if(response.user_id){
            dispatch(
              loginSuccess({ auth: { ...user.auth }, user: response })
            );
            dispatch(
              showToast({
                toast: toast,
                message:`Le règlement de l’échéance du (${user?.user?.due_date}) a été réalisé avec succès. Votre reçu vous a été envoyé par courrier électronique`,
                status: toastTypes.success,
              })
            );
            closeLoader(loadingRef);
            window.location.reload();
          }
          
        } else {
          closeLoader(loadingRef);
          dispatch(
            showToast({
              toast: toast,
              message: "Le paiement n'a pas été effectué.",
              status: toastTypes.error,
            })
          );
          // take them to booking detail page to make or verify payment
        }
      } else {
        closeLoader(loadingRef);
        dispatch(
          showToast({
            toast: toast,
            message: "Impossible d'effectuer le paiement pour le moment, veuillez réessayer plus tar",
            status: toastTypes.error,
          })
        );
      }
    },
    [
      verifyPayment,
      dispatch,
      toast,
      getUserProfile,
      user
    ]
  );
  const onSuccess = useCallback(
    (response: any) => {
      handlePayment(response);
    },
    [handlePayment]
  );

  const onClose = useCallback(() => {
    closeLoader(loadingRef);
  }, [loadingRef]);
  // useEffect(() => {
  //   initializePayment({ onSuccess, onClose });
  //   // eslint-disable-next-line
  // }, []);
  return (
    <>
      {/* q r code section */}
      <Box>
        <Flex
          h={{ md: "132px", base: "auto" }}
          bgImage="url(/images/img_frame_1000005236_132x1148.png)"
          bgSize="cover"
          bgRepeat="no-repeat"
          justifyContent="space-between"
          alignItems="center"
          // gap="20px"
          px={{ base: "20px", sm: "32px" }}
          borderRadius="16px"
        >
          <Image
            src="images/img_qrcode_ai_4ea58_104x138.png"
            alt="Code QR Image"
            h="104px"
            mt="28px"
            ml={{ md: "14px", base: "0px" }}
            borderTopRightRadius="16px"
            borderTopLeftRadius="16px"
            alignSelf="end"
            w="12%"
            fit="contain"
          />
          {user?.user?.tax_is_due && <Button
            size="2xl"
            colorScheme="red_origin"
            fontFamily="Arimo"
            textTransform="capitalize"
            fontWeight={600}
            minW="98px"
            borderRadius="8px"
            onClick={() => initializePayment({ onSuccess, onClose })}
          >
          payez
          </Button>}
        </Flex>
      </Box>
    </>
  );
}
